import { TableHeaderCategoryConfig } from "../../../../../components/tables/tableContext/TableContext";
import { ClientWorkingPointsDataInterface } from "../../../../../redux/interfaces/general.interface";
import { getWeekDaysByNumber } from "../../../../../utils/dateAndTime";

export const expeditionScheduleWorkingPointsTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      value: "searchAdresa",
      label: "Adresa",
      minW: 125,
      withSearch: true,
    },
    {
      value: "searchJudet",
      label: "Judet",
      withSearch: true,
    },
    {
      value: "searchLocalitate",
      label: "Localitate",
      withSearch: true,
      minW: 125,
    },
    {
      value: "searchPctLucru",
      label: "Punct de livrare client / asociat",
      withSearch: true,
      minW: 125,
    },
    {
      value: "searchPctLucruAsoc",
      label: "Nod / Ruta",
      minW: 125,
    },
    {
      label: "Status",
      value: "status",
      minW: 125,
    },
    {
      label: "Program",
      value: "program",
      minW: 125,
    },
  ];

export const getExpeditionScheduleWorkingPointsTableData: any = (
  data: ClientWorkingPointsDataInterface[],
) =>
  data?.map((item) => {
    return {
      id: item.idPctLucru,
      crudData: item,
      data: [
        {
          title: item.adresa,
        },
        {
          title: item.judet,
        },
        {
          title: item.localitate,
        },
        {
          badges: [
            {
              badgeText: item.pctDeLivrare ?? "-",
              badgeColor: "light-info",
            },
            {
              badgeText: item.pctDeLivrareAsociat ?? "-",
              badgeColor: "light-success",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.nod ?? "-",
              badgeColor: "light-info",
            },
            {
              badgeText: item.ruta ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.status ? "Validat" : "Nevalidat",
              badgeColor: item.status ? "light-success" : "light-danger",
            },
          ],
        },
        {
          title: getWeekDaysByNumber(item.program),
        },
      ],
    };
  });
